import { FEED_VIRTUALNAV, feedVirtualNavActionType, VirtualNav } from './types';

export const feedVirtualNav = (payload: VirtualNav): feedVirtualNavActionType => ({ type: FEED_VIRTUALNAV, payload });
